/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
import {
  makeType,
  parseOptions,
  initLog
} from '../core/base'

// import modernizr from "modernizr"
// var modernizr = require("modernizr");

import UI from '../core/ui'
import APIChannel from '../core/api_channel'

// import { getWith, maybe, first, guard } from "../ui/core/functions"
// import { guard } from "../core/functions"

import {
  getWith,
  maybe,
  first,
  guard,
  until
} from '../core/functions'

import {
  Stream
} from '../core/dispatcher-flyd'
import {
  modelChanged
} from './common'

const proto = {
  name: 'BackgroundSrcset',
  // injected: null,
  parseOptions,
  initLog,

  init() {
    return {
      url: null,
      tested: []
      // show: false,
      // content: null
    }
  },

  view(model) {

    maybe(url => {
      // popup.loadReponse(msg.content)
      this.dom.style.backgroundImage = `url('${url}')`
    })(model.url)

    // this.log.warn(`view: model:`, {... model})
    return model
  },

  update(msg, model) {
    // this.log.warn(`msg:`, {... msg})
    model = {
      ...model
    }

    // if (msg.type === 'webp') {
    //   model.url = this.dom.dataset.backgroundWebp
    // }

    switch (msg.type) {
      case 'webp':
        // this.log.warn(`setting webp`)
        model.url = this.dom.dataset.backgroundWebp
        model.tested.push('webp')

        break
        case 'no_webp':
          // this.log.warn(`setting webp`)
          // model.url = this.dom.dataset.backgroundWebp
          model.tested.push('webp')
          break
        case 'jpeg2000':
          // this.log.warn(`setting jpeg2000`)
          // this.log.warn(this.dom.dataset)
          // if (this.dom.dataset.backgroundJpg2000 != null) {
            model.url = this.dom.dataset.backgroundJpg2000
          // } else {

          // }
          //
          model.tested.push('jpeg2000')

          break
        // case 'no_jpeg2000':
        //   this.log.warn(`setting webp`)
        //   model.url = this.dom.dataset.backgroundWebp
        //   model.tested.push('jpeg2000')
        //   break

      default:
        model.url = this.dom.dataset.backgroundJpg
        // this.log.warn(`setting jpg: ${this.dom.dataset.backgroundJpg}`)

        // this.log.warn(`update: type: ${msg.type}`)
      }

      if (this.dom.dataset.backgroundJpg != null) {
        if (model.url == null) {
          // this.log.warn(`url not set`)
          if (model.tested.contains(`webp`) && model.tested.contains(`jpeg2000`)) {
            // this.log.warn(`set jpg`)
            model.url = this.dom.dataset.backgroundJpg
          }
        }
      }

    return model
  },

  initialize(dom) {
    this.dom = dom
    this.handlers = {}
    this.initLog()
    // this.log.warn("initializing:", this.dom)

    let currentModel = this.init()

    this.eventStream = new Stream()
    this.eventStream.map(msg => {
      let model = {
        ...currentModel
      }
      model = this.update(msg, model)
      if (modelChanged(currentModel, model)) {
        model = this.view(model)
      }
      currentModel = model
    })

    this.view(currentModel)

    Modernizr.on('webp', result => {
      if (result) {
        this.eventStream.stream({
          type: 'webp'
        })
      } else {
        // this.log.warn(`webp not available`)
        this.eventStream.stream({
          type: 'no_webp'
        })
      }
    });

    Modernizr.on('jpeg2000', result => {
      if (result) {
        this.eventStream.stream({
          type: 'jpeg2000'
        })
      } else {
        // this.log.warn(`jpeg2000 not available`)
        this.eventStream.stream({
          type: 'no_jpeg2000'
        })
      }
    });

  }
}

const BackgroundSrcset = makeType(proto)

UI.register('background_srcset', BackgroundSrcset)